import {request} from "@/shared/api/request";

export const sendRequest = (data) =>
    request({ url: `contract/persCard/saveAdnSend`, method: 'POST', data })
